import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  public isLoading = new Subject<boolean>();
  public loaded = false;
  show() {
    this.isLoading.next(true);
    this.loaded = true;
  }
  hide() {
    this.isLoading.next(false);
    this.loaded = false;
  }
}
